<template>
	<div>
		<post-smtp-widget
			v-if="!isMobileAppConfigured"
			class="mobile-wrapper"
		>
			<h3 class="mobile-header">
				{{ i18n.__( 'Checkout NEW Post SMTP', 'post-smtp' ) }}
				<br>
				<strong>{{ i18n.__( 'Mobile App', 'post-smtp' ) }}</strong>
			</h3>

			<ul class="mobile-unstyles-list">
				<li>{{ i18n.__( 'Instant notifications for failed emails.', 'post-smtp' ) }}</li>
				<li>{{ i18n.__( 'Resend emails directly from the app.', 'post-smtp' ) }}</li>
				<li>{{ i18n.__( 'Connect with multiple sites.', 'post-smtp' ) }}</li>
			</ul>

			<div class="img-wrapper">
				<post-smtp-img class="qrcode-img" :src="plugin_dir_url + 'assets/images/qrcode.png'" />
				<post-smtp-img class="qrcode-mobile-app" :src="plugin_dir_url + 'assets/images/mobile-app.svg'" />
			</div>
		</post-smtp-widget>

		<post-smtp-widget
			v-else-if="!isMainWpConfigured"
			class="post-smtp-main-wp-wrapper"
		>
			<div class="main-wp-header">
				<h3>
					{{ i18n.__( 'Easily Manage SMTP Configurations Across All Sites From', 'post-smtp' ) }}
					<span>{{ i18n.__( 'MainWP Dashboard' ) }}</span>
				</h3>
			</div>

			<ul class="main-wp-unstyled-list">
				<li>{{ i18n.__('One-stop SMTP Configuration', 'post-smtp') }}</li>
				<li>{{ i18n.__('Backup SMTP Connection', 'post-smtp') }}</li>
				<li>{{ i18n.__('Instant Email Failure Alerts', 'post-smtp') }}</li>
				<li>{{ i18n.__('Dedicated Mobile App (Free)', 'post-smtp') }}</li>
				<li>{{ i18n.__( 'Comprehensive Email Logging', 'post-smtp' ) }}</li>
			</ul>

			<div class="main-wp-footer">
				<a href="https://postmansmtp.com/mainwp-post-smtp/?utm_source=plugin&utm_medium=mainwp_banner&utm_campaign=plugin">
					{{ i18n.__( 'Get The Extension', 'post-smtp' ) }}
				</a>
			</div>
		</post-smtp-widget>

		<post-smtp-widget
			v-else-if="!isDomainSpamScoreConfigured"
			class="post-smtp-spam-score-wrapper"
		>
			<div>
				<div class="post-smtp-spam-score-header">
					<h2>
						{{ i18n.__( 'Check Your Domain', 'post-smtp' ) }}
						<br>
						<b>{{ i18n.__( 'Span Score', 'post-smtp' ) }}</b>
					</h2>
				</div>
				<ul class="post-smtp-spam-score-list-unstyled">
					<li>{{ i18n.__( 'Setup SPF, DKIM, and DMARC records for your domain', 'post-smtp' ) }}</li>
					<li>{{ i18n.__( 'Integrate your email service provider account with the website', 'post-smtp' ) }}</li>
					<li>{{ i18n.__( 'Test, analyze, and improve your website’s email deliverability', 'post-smtp' ) }}</li>
					<li>{{ i18n.__( 'Fix spam email for WordPress, WooCommerce, Shopify', 'post-smtp' ) }}</li>
					<li>{{ i18n.__( 'Improve sender score / IP reputation for your domain', 'post-smtp' ) }}</li>
				</ul>
				<div class="post-smtp-spam-score-footer">
					<a href="https://postmansmtp.com/domain-health-checker/?utm_source=plugin&utm_medium=dashboard_banner&utm_campaign=plugin">{{ i18n.__( 'Give it a try', 'post-smtp' ) }}</a>
				</div>
			</div>
		</post-smtp-widget>

	</div>
</template>

<script>

export default {
	name: 'PostSmtpAds',

	inject: ['i18n'],

	props: {
		isMobileAppConfigured : {
			type: Boolean,
			default: false,
		},
		isMainWpConfigured : {
			type: Boolean,
			default: false,
		},
		isDomainSpamScoreConfigured : {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),
}
</script>

<style scoped>
.mobile-wrapper {
	background: linear-gradient(180deg, #FFFFFF 50%, #DCE7FF 100%);
}

.mobile-wrapper * {
	padding: 0;
	margin: 0;
}

.mobile-header {
	font-family: Montserrat;
	font-size: 14px;
	font-weight: 500;
	line-height: 17.5px;
	text-align: left;
	color: #375CAF;
}

.mobile-header strong {
	font-family: Montserrat;
	font-size: 14px;
	font-weight: 700;
	line-height: 17.5px;
	text-align: left;
	color: #375CAF;
}

.post-smtp-main-wp-wrapper .main-wp-header h3 {
	color: #231F20;
	font-family: Montserrat;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 18.2px */
}

.post-smtp-main-wp-wrapper .main-wp-header h3 span {
	background: linear-gradient(269deg, #3662C7 18.26%, #32B495 47.83%, #B4D859 80.52%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Montserrat;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%;
}

.mobile-unstyles-list li {
	font-family: Montserrat;
	font-size: 11px;
	font-weight: 500;
	line-height: 13.75px;
	text-align: left;
	color: #646464;
	margin-top: 10px;
	list-style: url("../images/marker.svg") inside;
}

.img-wrapper {
	margin-top: 7px;
}

.img-wrapper::after {
	content: "";
	display: table;
	clear: both;
}

.qrcode-img {
	float: left;
	margin-top: 47px;
}

.qrcode-mobile-app {
	float: left;
}

.post-smtp-main-wp-wrapper {
	border-radius: 4px;
	border: 1px solid #DCDFE5;
	background: url( ../images/main-wp-bg.png ), linear-gradient(180deg, #FFF 0%, #EDF2FE 100%);
	padding: 24px 24px;
	background-position: right bottom;
	background-repeat: no-repeat;
}

.main-wp-unstyled-list {
	margin-bottom: 86px;
}

.main-wp-unstyled-list li {
	color: #646464;
	font-family: Montserrat;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13.75px; /* 13.75px */

	list-style: url( ../images/marker-2.svg ) inside;
}

.main-wp-footer a {
	display: inline-flex;
	padding: 10px 20px;
	justify-content: center;
	align-items: center;
	gap: 4px;

	color: #FFF;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px; /* 142.857% */

	border-radius: 50px;
	background: linear-gradient(312deg, #3662C7 21.21%, #32B495 64.57%, #B4D859 112.5%);
	text-decoration: none;
}

.post-smtp-spam-score-wrapper {
	border-radius: 4px;
	border: 1px solid #DCDFE5;
	background: url( ../images/spam-score-bg.png ), linear-gradient(180deg, #FFF 0%, #EDF2FE 100%);
	background-repeat: no-repeat;
	background-position: top right;
	padding: 20px 25px;
}

.post-smtp-spam-score-header h2 {
	color: #231F20;
	font-family: Montserrat;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20.8px; /* 20.8px */
}

.post-smtp-spam-score-header h2 span {
	font-weight: 700;
}

.post-smtp-spam-score-footer a {
	padding: 10px 20px;

	color: #FFF;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 142.857% */

	display: inline-flex;
	justify-content: center;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	background: #375CAF;

	text-decoration: none;
}

.post-smtp-spam-score-list-unstyled {
	margin-bottom: 20px;
}

.post-smtp-spam-score-list-unstyled li {
	color: #646464;
	font-family: Montserrat;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13.75px;

	list-style: url("../images/marker-3.svg") inside;
}
</style>